import { useSelector } from "react-redux";
import { getUserId, isFormLoading } from "./selectors";

export default function useProfileState() {
	const id = useSelector(getUserId);
	const loading = useSelector(isFormLoading);

	return {
		id,
		loading,
	};
}
